import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IOScoords } from '../classes/geo-location-object';


@Injectable({
  providedIn: 'root'
})
export class IosService {
  location$: BehaviorSubject<IOScoords> = new BehaviorSubject(null)
  constructor() { }

  updateLocationData(data: IOScoords): void {
    this.location$.next(data);
  }

  getLocationData(): Observable<IOScoords> {
    return this.location$.asObservable();
  }

  // TODO add type once I know the data structure
}
